import { axiosGet } from '../../axios/axios.js'
import FilesGroup from '../../components/File/FilesGroup.js'
import store from '../../pages/main/store'

const getUser = () => store.getters.getUser

export const ACTIONS = [
  {
    key: 'cancel',
    btnLabel: 'Аннулировать',
    headerLabel: 'Аннулировать?',
    approveBtnLabel: 'Подтвердить',
    btn: true,
    color: 'negative',
    displayFn: record => {
      if (record.hasIncident && (record.incidentData.requestToCheck || record.incidentData.checkCompleted || record.incidentData.source === 'ski')) {
        return false
      }
      if (record.operationHistory.some(operation => operation.noteStatus && operation.noteStatus.key === 'fixed')) {
        return false
      }
      return (getUser().hasRole && getUser().hasRole('admin') || getUser().hasRole && getUser().hasRole('dispather') || record.authorFIO === getUser().name) && record.maintenanceNoteStatus && record.maintenanceNoteStatus.key !== 'canceled'
    }
  },
  {
    key: 'cancelCancel',
    btnLabel: 'Отменить аннулирование',
    headerLabel: 'Отменить аннулирование?',
    approveBtnLabel: 'Подтвердить',
    btn: true,
    color: 'negative',
    displayFn: record => {
      if (record.hasIncident && (!record.incidentData.cancelled || record.incidentData.source === 'ski')) {
        return false
      }
      return record.maintenanceNoteStatus && record.maintenanceNoteStatus.key === 'canceled'
    }
  },
  {
    key: 'fix',
    toMaintenanceNoteStatus: 'fixed',
    btnLabel: 'Устранено',
    headerLabel: 'Устранено',
    approveBtnLabel: 'Сохранить',
    btn: true,
    color: 'positive',
    displayFn: record => {
      if (record.hasIncident && (record.incidentData.requestToCheck || record.incidentData.problemStatus !== 'opened')) {
        return false
      }
      return record.maintenanceNoteStatus && record.maintenanceNoteStatus.key === 'notFixed'
    },
    additionalConditions: [
      {
        checkCondition: record => {
          return !(record && record.fixInSkiMode)
        },
        negativeMessage: 'Действие запрещено по причине установки для данного инцидента режима "Регистрация устранения инцидента в интерфейсе СКИ".\nВ указанном режиме регистрация устранения инцидента выполняется только в интерфейсе СКИ.\nПри необходимости, указанный режим может быть отключен в карточке данного инцидента, в интерфейсе СКИ.'
      }
    ]
  },
  {
    key: 'notfix',
    toMaintenanceNoteStatus: 'notFixed',
    btnLabel: 'Не устранено',
    headerLabel: 'Не устранено',
    approveBtnLabel: 'Сохранить',
    btn: true,
    color: 'negative',
    displayFn: record => {
      if (record.hasIncident && (record.incidentData.checkCompleted && record.incidentData.problemStatus === 'closed' || !record.incidentData.requestToCheck)) {
        return false
      }
      return record.maintenanceNoteStatus && record.maintenanceNoteStatus.key === 'fixed'
    }
  },
  { key: 'comment', btnLabel: 'Добавить комментарий', headerLabel: 'Комментарий', approveBtnLabel: 'Сохранить', btn: true, color: 'primary' },
  { key: 'edit', headerLabel: 'Редактирование', approveBtnLabel: 'Сохранить', btn: false },
  { key: 'delete', headerLabel: 'Удалить?', approveBtnLabel: 'Подтвердить', btn: false }
]

//  maintenanceNoteStatus:
//  notFixed("Не устранено"),
//  fixed("Устранено"),
//  canceled("Аннулировано");

export function getMaintenanceNoteStatusColor (note) {
  const key = note && note.key
  if (key === 'notFixed') {
    return 'negative'
  } else if (key === 'fixed') {
    return 'positive'
  } else if (key === 'canceled') {
    return 'grey-7'
  } else {
    return 'white'
  }
}
export function getEnumValues (key) {
  return axiosGet({
    url: '/service/delta/journal/serviceobjectmaintenancenotes/getEnumValues',
    onSuccess: (response) => {
      let result = []
      if (response.data.result) {
        result = response.data.result[key].value
      }
      result = result.map(r => {
        return { name: r.name, key: r.value }
      })
      if (key === 'commentType') {
        result = result.filter(r => r.key !== 'created')
      }
      return result
    }
  })
}

export function prepareRecord (recordFromServer) {
  const record = JSON.parse(JSON.stringify(recordFromServer))

  record._filesGroup = new FilesGroup({
    key: 'serviceObjectMaintenanceNotes',
    sourceConfig: {
      objectId: record.id,
      uploadURL: '/service/delta/document/upload',
      removeURL: '/service/delta/document/deleteFromObject'
    }
  })

  if (record.photos && record.photos.length) {
    record._filesGroup.pushFiles(record.photos.map(photoId => {
      return { id: photoId, name: 'Замечание к объекту' + '-' + photoId }
    }))
  }

  return record
}
